import { User } from "~/entities/user/types";

const TrustPilotScript: React.FC<{ nonce: string }> = ({ nonce }) => (
  <script
    nonce={nonce}
    src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
    async
  />
);

const Scripts: React.FC<{ nonce: string; user: User | null }> = ({
  nonce,
  user,
}) => {
  if (user?.doNotSellMyInformation) {
    return <TrustPilotScript nonce={nonce} />;
  }

  return (
    <>
      <script
        nonce={nonce}
        data-testid="frontAppChat"
        src="https://chat-assets.frontapp.com/v1/chat.bundle.js"
      />
      <TrustPilotScript nonce={nonce} />
      <script
        nonce={nonce}
        id="merchantWidgetScript"
        src="https://www.gstatic.com/shopping/merchant/merchantwidget.js"
        defer
      />
    </>
  );
};

export default Scripts;
